module.exports = __webpack_public_path__ + "static/media/no-friends-dark.b02b613b.svg";